import { RATING_STAGE } from 'components/Csat/constants';
import type { WorkflowsState } from '.';

const initialState: WorkflowsState = {
  actionToExecAfterPrivacyConsented: null,
  consentedPrivacyPolicyHash: null,
  conversationId: '',
  conversationIdUsedInPreviousSession: '',
  conversationStatus: 'initial',
  csatConfig: {
    csatType: 'inline',
    didSubmit: false,
    isCsatDetailVisible: false,
    isCsatEndTransition: false,
    isCsatSurveyFinished: false,
    isCsatVisible: false,
  },
  csatFormData: {
    csatFeedback: [],
    csatResolve: undefined,
    csatScore: 0,
    isCsatDataSubmitted: false,
  },
  csatStates: {
    actionToExecuteAfterCsatDismiss: null,
    additionalFeedback: '',
    currentStage: RATING_STAGE,
    hasDismissed: false,
    hasFeedbackTooltipPrompted: false,
    hasSubmitted: false,
    highRatingReasonIndices: [],
    isCsatVisible: false,
    isEditing: false,
    isPromptDisabledForMinimize: false,
    isResolved: undefined,
    lowRatingReasonIndices: [],
    rating: -1,
    submittedRating: undefined,
    triggeredFrom: null,
  },
  csatTranslatedText: null,
  customConfigParams: {},
  customParams: {},
  didProactiveBubblesShownTrackingEventGetSent: false,
  didUserCloseProactiveChat: false,
  didUserRestartConversation: false,
  dismissableNotification: '',
  enabled_feature_flags: [],
  error: null,
  externalEventAutomations: [],
  floatingBarSearchLoading: false,
  floatingBarSearchResult: undefined,
  freeFormQuery: '',
  handoffFailureMessage: null,
  handoffIntegration: null,
  handoffStatus: 'not_started',
  initialIntentId: '',
  initialQuery: '',
  intentId: '',
  intentTitle: '',
  interactiveEmailDeflectionFeedback: null,
  isAutonomousAgentWorkflowPreview: false,
  isBrowserAgentInProgress: false,
  isBuilderPreview: false,
  isFirstConversation: undefined,
  isFloatingBarFocused: false,
  isFreshdeskFileSent: false,
  isModelTraining: false,
  isScrollAtTheBottom: true,
  isSolveConfigPreview: false,
  isUploadingAttachment: false,
  knowledgeSearchQuery: '',
  lastProactiveTriggerId: '',
  loading: false,
  messageDelays: [],
  modifiedDate: null,
  nextStepId: '',
  noUserActionsLeft: false,
  numOfUserActions: 0,
  parentUrl: '',
  persistedLiveChatComponents: null,
  previousIntentIds: [],
  proactiveTriggers: [],
  quickFeedback: {
    mobileClickedStepIndex: null,
    steps: {},
  },
  screenReaderNotifications: [],
  selectedArticle: undefined,
  selectedIntentIndex: null,
  sessionId: null,
  shouldFocusReceivedMessage: false,
  shouldFocusTextInput: false,
  shouldInitLogRocket: false,
  sipCallState: {
    audioAccess: null,
    isVisible: false,
    readyToCall: false,
    roomUrl: undefined,
    sipUri: undefined,
    token: undefined,
  },
  streaming: false,
  systemTimeDelta: 0,
  touchedFormFields: [],
  transcriptLength: null,
  triggerEvent: Object.freeze({
    triggerEventExpectedContextVariables: [],
    triggerEventExpectedEventId: '',
    triggerEventExpectedEventName: '',
    triggerEventPayload: {
      contextVariables: {},
      eventName: '',
    },
    triggerEventStatus: 'not_started',
  }),

  // use `false` by default until we receive an actual value:
  widget_enabled: false,
  widgetComponents: [],
  widgetSearchLoading: false,
  widgetSearchResult: undefined,
  windowUpdatedContextVariables: {},
  workflowsConfig: null,
  workflowVersion: '',
};

export default initialState;
